<template>
    <div>
        <van-nav-bar
                :title="info.express_status_name"
                left-text="返回"
                right-text=""
                left-arrow
                @click-left="onNavClickLeft"
        />

        <div class="order-panel">
            <div class="label-panel">
                <span class="label">快递公司</span>
                <span class="val">{{info.express_company}}</span>
            </div>
            <div class="label-panel">
                <span class="label">快递单号</span>
                <span class="val">{{info.express_number}}</span>
            </div>
            <div class="label-panel">
                <span class="label">订单编号</span>
                <span class="val">{{info.order_code}}</span>
            </div>
            <div class="label-panel">
                <span class="label">收货人</span>
                <span class="val">{{info.customer_name}}</span>
            </div>
            <div class="label-panel">
                <span class="label">收货地址</span>
                <span class="val">{{info.customer_address}}</span>
            </div>
        </div>

        <div class="step">
            <van-steps direction="vertical" :active="0">
                <van-step v-for="(item,index) in info.list" :key="index" >
                    <h4>{{item.status}}</h4>
                    <p>{{item.time}}</p>
                </van-step>
            </van-steps>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        name: "OrderExpressDetail",
        data(){
            return {
                order_id:this.$route.params.order_id,
                info:{list:[]}
            }
        },
        methods:{
            ...mapActions([
                'GetSaleOrderExpressInfo',
            ]),
            onNavClickLeft(){
                this.$router.go(-1);
            },
            loadData(){
                let order_id=this.order_id;
                this.GetSaleOrderExpressInfo({order_id}).then(res=>{
                    console.log(res);
                    if(res){
                        this.info=res;
                        this.info.list = JSON.parse(res.express_text);
                        console.log(this.info.list);
                    }
                })
            }
        },
        mounted() {
            this.loadData();
        }
    }
</script>

<style lang="scss" scoped>
    .order-panel{
        background-color: #FFFFFF;
        margin: 14px;
        text-align: left;
        border-radius: 10px;
        .title-banner{
            padding: 5px;
            text-align: left;
            .title{
                font-size: 14px;
                color: #333333;
                font-weight: bold;
            }
            .help-icon{
                font-size: 18px;
                color: #666666;
                float: right;
            }
        }
        .label-panel{
            padding-top: 6px;
            padding-left: 10px;
            .label{
                font-size: 12px;
                color: #999999;
            }
            .val{
                padding-left: 30px;
                font-size: 12px;
                color: #999999;
            }
        }

    }
    .step{
        text-align: left;
        font-size: 12px;
    }
</style>
